// LoginModal.tsx
import React from "react";

import LoginFormContainer from "./Form/LoginForm";
import Modal from "../Reusable/Modal";
import { useModal } from "../../context/ModalContext";

const LoginModal: React.FC = () => {
  const { isLoginOpen, closeLoginModal, openConfirmationModal } = useModal();

  return (
    <Modal
      isOpen={isLoginOpen}
      onClose={closeLoginModal}
      className="w-[90%] md:w-[426px]"
    >
      <LoginFormContainer
        closeLoginModal={closeLoginModal}
        onSuccess={() => {
          // We don't need to close the login modal here since it's already closed in the form's onSubmit
          openConfirmationModal();
        }}
      />
    </Modal>
  );
};

export default LoginModal;
